import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AttendanceModal from '@calendar/components/Modals/AttendanceModal.vue'
import ReadForm from '@calendar/components/Read/ReadForm.vue'
import * as dateutil from '@/util/date-helper'
import * as accountTypes from '@account/store/types'
import * as types from '@calendar/store/types'
import { mapGetters, mapMutations } from 'vuex'
import api from '@calendar/api'

@Component({
  components: {
    AttendanceModal, ReadForm
  },
  computed: {
    ...mapGetters({
        User: accountTypes.USER,
        //item: types.CURRENT_CALENDAR_ITEM
    }),
  },
  methods: {
    ...mapMutations({
      setCalendarItem: types.CURRENT_CALENDAR_ITEM
    })
  }
})
export default class ReadContainer extends Vue {

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  User!: account.User
  //item!: calendar.CalendarItem

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  setCalendarItem!: (item: calendar.CalendarItem) => void

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  // 이수 - 회의실 목록에 db 자원관리 회의실 목록과 연동
  conferenceList: calendar.ConferenceResourceItem[] = [];
  conferenceId: number | string = ''
  reserveRequestId: number | null = null
  selectConference: calendar.ConferenceResourceItem | null = null
  
  reserveRequestItem: calendar.RequestCalendarMapItem | null = null
  conference: any | null = null

  bodyLoaded: boolean = false
  showAttendanceModal: boolean = false

  item: calendar.CalendarItem = {
    body: '',
    pidLidRecurrenceType: 1,
    //attachments: [] as any,
    hasAttachments: false,
    location: '',
    subject: '',
    code: '',
    codeValues: [] as string[],
    status: 'S0',
    resourceId: null,
    resources: [] as Array<any>,
    ui_resourceArray: [] as Array<any>,
    recurrence: {
      startDate: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
      endDate: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
      ui_useRecurringButton: true,
      ui_useDefaultDate: true,
      ui_useRecurringDisplay: false,
      ui_useRecurring: false,
      ui_recurringType: 1,
      ui_endType: '1',
      monthValue: (new Date().getMonth() + 1),
      firstDayOfWeekValue: 1,
      daysOfTheWeekArray: [] as number[],
      interval: 1,
      numberOfOccurrences: 0,
    } as calendar.CalendarItemRecurrence,
    isReadyData: false,
    isEWS: false,
    delegateUser: '',
  } as unknown as calendar.CalendarItem

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  /**
   * 일정을 수락합니다
   */
   accept() {
    if (this.item && this.item.id) {
      api.ews_calendar.acceptEvent(this.item.id).then((res) => {

      })
    }
  }

  /**
   * 일정을 거절합니다
   */
  decline() {
    if (this.item && this.item.id) {
      api.ews_calendar.declineEvent(this.item.id).then((res) => {
        
      })
    }
  }

  /**
   * 참석자 태그
   * @param list
   */
    convertRecToTag(list?: mail.EwsRecipient[]) {
    return (
      list?.map((r) => ({
        text: r.name,
        value: r.address,
      })) || []
    )
  }

  load() {
    let _target = this.$route.query.target || this.item.target
    let _id = (this.$route.query.itemid as string) || this.item.id
    let _occitem = (window as any).opener?.occitem || (this.$route.query.occitem as string)
    let sitem: calendar.CalendarItem | null = null

    if (_occitem) {
      sitem = JSON.parse(decodeURIComponent(_occitem)) as calendar.CalendarItem
    }

    let action: Promise<any> = Promise.resolve()

    if (_target !== 'MY' && _target !== 'SHARE') {
      if (sitem != null && sitem.appointmentType === 'Exception') {
        action = api.db_calendar.getRCalendarEvent({
          ID: Number(sitem.id),
          PersonCode: (this.User as any).personCode,
        })
      } else {
        action = api.db_calendar.getCalendarEvent({
          ID: Number(_id),
          PersonCode: (this.User as any).personCode,
        })
      }
    } else {
      action = api.ews_calendar.getDetail(_id)
    }

    // const uid = `uid-${Date.now()}`;
    // this.item.code = `CALENDAR_${this.User.id}_${uid}`;
    // this.item.codeValues = ['FL', 'Calendar', this.User.email, uid];
    return action
      .then(async (citem) => {
        if (sitem != null && sitem.db_masterID && sitem.appointmentType != 'Exception') {
          citem = {
            ...citem,
            ...sitem,
          }
        }

        if (citem.code) {
          const uid = 'uid-' + citem.code.split('uid-')[1]
          citem.codeValues = [this.User.comCode, 'Calendar', this.User.email, uid]
        }

        citem.isAllowAccept = false
        citem.isAllowCancel = false
        citem.isAllowDecline = false
        citem.isAllowDelete = false
        citem.isAllowUpdate = false

        if (_target == 'MY') {
          if (citem.allowedResponseActions) {
            citem.isAllowAccept = citem.allowedResponseActions.indexOf('Accept') != -1
            citem.isAllowDecline = citem.allowedResponseActions.indexOf('Decline') != -1
            citem.isAllowCancel = citem.allowedResponseActions.indexOf('Cancel') != -1
          }

          citem.isAllowUpdate = citem.organizer?.address == this.User.email
          citem.isAllowDelete = true || citem.organizer?.address == this.User.email

          if (citem.isAllowCancel) {
            let repCount =
              (citem.requiredAttendees || []).filter((x: any) => x.address != this.User.email)
                .length +
              (citem.optionalAttendees || []).filter((x: any) => x.address != this.User.email)
                .length
            if (!repCount) {
              citem.isAllowCancel = false
            } else {
              if (
                [...citem.requiredAttendees, ...citem.optionalAttendees].filter(
                  (x) => !x.address || x.address.indexOf('@') == -1
                ).length
              ) {
                citem.isAllowCancel = false
              }
            }
          }
        } else {
          if (_target == 'CM') {
            if (citem.update) {
              citem.isAllowUpdate = citem.organizer?.address == this.User.email
            }

            if (citem.delete) {
              citem.isAllowDelete = citem.organizer?.address == this.User.email
            }
          } else if (_target == 'DC') {
            citem.isAllowUpdate = citem.organizer?.address == this.User.email
            citem.isAllowDelete = citem.organizer?.address == this.User.email
          }
        }

        citem.parentId = (citem as any).parentFolderId

        if (citem.start && (citem.start.indexOf(' ') != -1 || citem.start.indexOf('T') != -1)) {
          citem.starttime = dateutil.DateAndTimeSplitor(citem.start)[1]
          citem.start = dateutil.DateAndTimeSplitor(citem.start)[0]
        }

        if (citem.end && (citem.end.indexOf(' ') != -1 || citem.end.indexOf('T') != -1)) {
          citem.endtime = dateutil.DateAndTimeSplitor(citem.end)[1]
          citem.end = dateutil.DateAndTimeSplitor(citem.end)[0]
        }

        if (typeof citem.isAllDayEvent === 'string') {
          citem.isAllDayEvent = (citem.isAllDayEvent as any) === 'True' ? true : false
          // 하루종일 일정일 경우 end에서 하루를 빼줘야 함
          if (citem.isAllDayEvent) {
            let eDate = dateutil.IEDate(citem.end)
            eDate.setDate(eDate.getDate() - 1)
            citem.end = dateutil.uGetDateFormat('yyyy-MM-DD', eDate)
          }
        }
        // if (typeof citem.isAllDayEvent == typeof '') {
        //   citem.isAllDayEvent = (citem.isAllDayEvent as any) === 'True' ? true : false
        // }

        citem.requiredAttendees = this.convertRecToTag(citem.requiredAttendees) as any
        citem.optionalAttendees = this.convertRecToTag(citem.optionalAttendees) as any

        if (!citem.recurrence) {
          citem.recurrence = Object.create(null)
          Object.assign(citem.recurrence, this.item.recurrence)
          citem.pidLidRecurrenceType = 1
        }

        if (citem.pidLidRecurrenceType) {
          citem.recurrence.ui_recurringType = citem.pidLidRecurrenceType
        }

        switch (citem.appointmentType) {
          case 'Single':
            citem.recurrence.ui_useRecurringButton = true
            citem.recurrence.ui_useDefaultDate = true
            citem.recurrence.ui_useRecurringDisplay = false
            citem.recurrence.ui_useRecurring = false
            break
          case 'RecurringMaster':
            citem.recurrence.ui_useRecurringButton = true
            citem.recurrence.ui_useDefaultDate = false
            citem.recurrence.ui_useRecurringDisplay = true
            citem.recurrence.ui_useRecurring = true
            break
          case 'Occurrence':
          case 'Exception':
            citem.recurrence.ui_useRecurringButton = false
            citem.recurrence.ui_useDefaultDate = true
            citem.recurrence.ui_useRecurringDisplay = true
            citem.recurrence.ui_useRecurring = true
            break
          default:
            citem.recurrence.ui_useRecurringButton = true
            citem.recurrence.ui_useDefaultDate = true
            citem.recurrence.ui_useRecurringDisplay = false
            citem.recurrence.ui_useRecurring = false
            break
        }

        this.setCalendarItem({
          ...this.item,
          ...citem,
        })
        this.item = {
          ...this.item,
          ...citem,
        }

        if (this.item.isEWS) {
          const [res, body] = await Promise.all([
            api.ews_resource.getRooms(),
            api.ews_calendar.getBody(citem.id),
          ])
          this.item.ui_resourceArray = [
            { text: 'None', value: null },
            ...(res as Array<any>)
              .filter((x) => x.depth == 1)
              .map((x) => {
                return { text: x.name, value: x.address }
              }),
          ]
          this.item.isReadyData = true
          this.item.body = body
          this.bodyLoaded = true
        } else {
          this.bodyLoaded = true
          if (this.item.isAllowUpdate) {
            //this.item.body = this.removeBigFileHtml(this.item.body);
          }
          const res = await api.db_resource.getFindCalendarResource({ Type: 'RM' })
          this.item.ui_resourceArray = [
            { text: 'None', value: null },
            ...res.map((x) => {
              return { text: x.displayName, value: x.id }
            }),
          ]
          this.item.isReadyData = true
        }
      })
      .catch((err) => {
        console.log('loadErr', err)
      })
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  async mounted() {
    //this.loading(true)
    try {
      await this.load()

      if (
        this.item.start &&
        (this.item.start.indexOf(' ') != -1 || this.item.start.indexOf('T') != -1)
      ) {
        this.item.starttime = dateutil.DateAndTimeSplitor(this.item.start)[1]
        this.item.start = dateutil.DateAndTimeSplitor(this.item.start)[0]
      }

      if (this.item.end && (this.item.end.indexOf(' ') != -1 || this.item.end.indexOf('T') != -1)) {
        this.item.endtime = dateutil.DateAndTimeSplitor(this.item.end)[1]
        this.item.end = dateutil.DateAndTimeSplitor(this.item.end)[0]
      }

      if (typeof this.item.isAllDayEvent == typeof '') {
        this.item.isAllDayEvent = (this.item.isAllDayEvent as any) === 'True' ? true : false
      }
    } catch (err) {
      console.error(err)
    }
    //this.loading(false)

    api.db_resourceReserve.getConferenceResource(this.User.comCode).then((res: any[]) => {
      this.conferenceList = res
      this.conferenceReserveCheck();
    })
  }

  created() {
    
  }

  conferenceReserveCheck() {
    api.db_resourceReserve.getMapByCalendarItemId(encodeURIComponent(this.item.id)).then((res: any) => {
        console.log('res', res)
        if (res) {
            this.reserveRequestItem = res
            this.conferenceId = res.reserveResourceId
            this.reserveRequestId = res.reserveRequestId
            this.conference = this.conferenceList.find((x: any) => x.resourceId == this.reserveRequestItem?.reserveResourceId)
            this.$emit('setReserveRequestItem', this.reserveRequestItem)
        }
    })
  }
}
